import { setUserProperties } from 'firebase/analytics';
import { useEffect } from 'react';

import { analytics } from '@/app/providers/firebase';

import { eventTracker } from '../utils/event-tracker';
import { getUtmParams } from '../utils/get-utm-params';

export function getCurrentUrl(): string {
  return window.location.pathname + window.location.search;
}

export function useRouteChange(): void {
  useEffect(() => {
    const handleRouteChange = (): void => {
      const fullPath = getCurrentUrl();
      const previousUrl = window.current_url;
      window.previous_url = previousUrl ?? '';
      window.current_url = fullPath;

      // Clear event tracking for the new route
      eventTracker.setCurrentRoute(fullPath);

      const utmParams = getUtmParams();
      if (utmParams !== null) {
        setUserProperties(analytics, utmParams);
      }
    };

    handleRouteChange();

    window.addEventListener('popstate', handleRouteChange);

    const originalPushState = history.pushState.bind(history);
    const originalReplaceState = history.replaceState.bind(history);

    history.pushState = function (this: History, ...args) {
      originalPushState(...args);
      handleRouteChange();
    };

    history.replaceState = function (...args) {
      originalReplaceState.apply(this, args);
      handleRouteChange();
    };

    return () => {
      window.removeEventListener('popstate', handleRouteChange);
      history.pushState = originalPushState;
      history.replaceState = originalReplaceState;
    };
  }, []);
}
